<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content batch-item-list-dialog__content">
  <p class="batch-item-list-dialog__message">{{ data.message }}</p>

  <div class="mbp-table-wrap">
    <table mat-table matSort [dataSource]="scanBatchItems" class="mbp-data-table batch-item-list-dialog__table">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="id-col">#</th>
        <td mat-cell *matCellDef="let item" class="id-col">{{ item.item.id }}</td>
      </ng-container>

      <ng-container matColumnDef="in_stock">
        <th mat-header-cell *matHeaderCellDef class="check-col">In stock</th>
        <td mat-cell *matCellDef="let item" class="check-col">
          <span class="batch-item-list-dialog__checkbox">
            <mat-checkbox
              [disableRipple]="true"
              (click)="$event.preventDefault()"
              color="primary"
              [checked]="isInStock(item.item)"
            >
            </mat-checkbox>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="scanned">
        <th mat-header-cell *matHeaderCellDef class="check-col">Scanned</th>
        <td mat-cell *matCellDef="let item" class="check-col">
          <span class="batch-item-list-dialog__checkbox">
            <mat-checkbox
              [disableRipple]="true"
              (click)="$event.preventDefault()"
              color="primary"
              [checked]="item.scanned"
            >
            </mat-checkbox>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef>Barcode</th>
        <td mat-cell *matCellDef="let item" class="barcode-col">
          <mat-form-field appearance="outline" class="batch-item-list-dialog__barcode-field" subscriptSizing="dynamic">
            <input
              required
              matInput
              id="{{ item.inputId }}"
              [formControl]="item.barcodeControl"
              placeholder="Barcode"
            />
          </mat-form-field>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="actions-col">&nbsp;</th>
        <td mat-cell *matCellDef="let item" class="actions-col">
          <div class="batch-item-list-dialog__row-actions">
            <button type="button" class="batch-item-list-dialog__btn" (click)="focusItem(item)" mat-stroked-button>
              Scan
            </button>
            <button
              type="button"
              class="batch-item-list-dialog__btn batch-item-list-dialog__btn--primary"
              [disabled]="item.barcodeControl.invalid"
              (click)="submit(item)"
              mat-flat-button
              color="primary"
            >
              Submit
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator
    class="batch-item-list-dialog__paginator"
    [length]="totalNumberOfBatchItems"
    [pageIndex]="page - 1"
    [pageSize]="limit"
    [pageSizeOptions]="[5, 10, 15]"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of batch items"
  >
  </mat-paginator>
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button type="button" mat-flat-button (click)="closeDialog()" color="primary" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Done
  </button>
</div>
